import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { isEmpty } from 'lodash';
import Input from '../components/Input';
import Textarea from '../components/Textarea';
import Select from '../components/Select';

const Button = styled.button`
  border-radius: 0px !important;
  background-color: #fa5a56 !important;
  border-color: #fa5a56 !important;
  min-width: 15rem;
  margin-top: 1rem;
`;

const validate = (values) => {
  const errors = {};
  if (isEmpty(values.name)) {
    errors.name = <FormattedMessage id="Form.Error.Required" />;
  }
  if (isEmpty(values.email)) {
    errors.email = <FormattedMessage id="Form.Error.Required" />;
  }
  if (isEmpty(values.reasonForContract)) {
    errors.reasonForContract = <FormattedMessage id="Form.Error.Required" />;
  }
  if (isEmpty(values.message)) {
    errors.message = <FormattedMessage id="Form.Error.Required" />;
  }
  return errors;
};

// eslint-disable-next-line import/no-mutable-exports
class ContactUs extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
  }

  render() {
    const {
      handleSubmit,
      submitting,
      isLoading,
      intl,
    } = this.props;

    return (
      <form onSubmit={handleSubmit}>
        <Field
          name="name"
          label={intl.formatMessage({
            id: 'Form.ContactUs.Name',
          })}
          component={Input}
          type="text"
          disabled={submitting || isLoading}
        />
        <Field
          name="email"
          label={intl.formatMessage({
            id: 'Form.ContactUs.Email',
          })}
          component={Input}
          type="email"
          disabled={submitting || isLoading}
        />
        <Field
          name="reasonForContract"
          label={intl.formatMessage({
            id: 'Form.ContactUs.ReasonForContract',
          })}
          component={Select}
          data={[
            {
              label: <FormattedMessage id="Form.ContactUs.Exhibition" />,
              value: 'Exhibition',
            },
            {
              label: <FormattedMessage id="Form.ContactUs.FleaMarket" />,
              value: 'Flea Market',
            },
            {
              label: <FormattedMessage id="Form.ContactUs.Workshop" />,
              value: 'Workshop',
            },
            {
              label: <FormattedMessage id="Form.ContactUs.Others" />,
              value: 'Others',
            },
          ]}
          disabled={submitting || isLoading}
        />
        <Field
          name="message"
          label={intl.formatMessage({
            id: 'Form.ContactUs.Message',
          })}
          component={Textarea}
          rows={5}
          disabled={submitting || isLoading}
        />
        <div className="d-flex flex-row justify-content-center">
          <Button
            type="submit"
            className="btn btn-success btn-lg"
            disabled={submitting || isLoading}
          >
            {submitting || isLoading ? (
              <FontAwesomeIcon
                icon="spinner"
                pulse
              />
            ) : intl.formatMessage({
              id: 'Form.ContactUs.Submit',
            })}
          </Button>
        </div>
      </form>
    );
  }
}

// eslint-disable-next-line no-class-assign
ContactUs = reduxForm({
  form: 'CONTACT_US',
  validate,
})(ContactUs);

export default injectIntl(ContactUs);
